import React, { useContext, useEffect, useState } from 'react';
import bgImage from '../../../assets/images/couples/Vector.png';

import { SignupContext } from '../../../context/SignupContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// const API_BASE_URL = 'http://localhost/perfomdigi/hindu-humsfar-react/backend/'; 


const SendOtp = () => {


  const { APIformData, setAPIFormData, userName, userId, isLoggedIn } = useContext(SignupContext);
  const navigate = useNavigate();
  const [imobile, setMobile] = useState(null);
  const [error, setError] = useState(null);


  useEffect(() => {
    if(!isLoggedIn){
      navigate('/sign-up')
    }
  }, []);


  const validateMobile = (value) => {
    const pattern = /^[6-9]\d{9}$/;
    return pattern.test(value);
  };




  const handleMobile = async (e) => {
    e.preventDefault();
    if (!imobile.trim()) setError("Mobile is required");
    else if (validateMobile(imobile)) setError("Invalid mobile number.\nMust start with 6-9 and be 10 digits.");
    else setError("");
    if (imobile.trim() != "" && validateMobile(imobile)) {
      setError("");
      /////set context for data 
      setAPIFormData(prev => ({ ...prev, mobile: imobile }));
      /////sending otp from server
      const payload = new FormData();

      payload.append("mobile", imobile);
      payload.append("UserID", userId);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/Register_controller/send_otp`,
        payload
      );

      if (response.data.response == "failed") {
        setError(response.data.message);
      }
      else if (response.data.response == "success") {
        setError('');

        navigate("/otp");
      } else {
        setError("Something Went Wrong\nTry Again");
      }

    } else {
      setError("Invalid mobile number.\nMust start with 6-9 and be 10 digits.")
    }

  }



  return (
    <>
      <div className='py-md-5'></div>

      <div className='reset-wrapper'>
        <div className="reset-container">
          <div className="reset-left">
            <div className=''>


              <h2 className='text-center' style={{ textTransform: "capitalize" }}>Hii {userName} </h2>
              <p className="text-center">Confirm your Number for Otp</p>
              <p className="subtitle text-center">Your Email: {APIformData.email}</p>

              {error && <div className='alert alert-danger' >{error}</div>}


              <form className="reset-form" onSubmit={handleMobile}   >
                <label>Mobile Number <span>*</span></label>
                <input type="text" onChange={(e) => setMobile(e.target.value)} placeholder="Enter your Number" required />


                <button type="submit" className="reset-button">Send Otp</button>
              </form>
            </div>
          </div>

          <div className="reset-right">
            <div className="image-overlay d-none d-lg-block">
              <img src={bgImage} alt="Side Visual" className="side-image" />
              <div className="image-text">
                <h3>Your Journey To Love Begins <span className="highlight">Here !</span></h3>
                <p>Connect With Genuine Matches Who<br />Share Your <span className="highlight">Values</span> And <span className="highlight">Dreams</span>.</p>
              </div>
            </div>
            <style>
              {`

.reset-wrapper{  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  padding: 20px;  }


            .reset-container {
 width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #white;
  padding: 20px;
  max-width:1200px;
  margin:0 auto;
  background:white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.reset-left {
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}


.reset-left h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
}

.subtitle {
  color: #666;
  margin-bottom: 30px;
}

.reset-form label {
  display: block;
  font-weight: 500;
  margin-bottom: 6px;
}

.reset-form span {
  color: red;
}

.reset-form input {
  width: 100%;
  padding: 9.5px 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
}

.reset-button {
  width: 100%;
  padding: 12px;
  background-color: #E53D5C;
  color: white;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}

.reset-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-overlay {
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  max-width: 500px;
  width: 100%;
}

.side-image {
  width: 100%;
  height: auto;
  display: block;
}

.image-text {
  position: absolute;
  bottom: 30px;
  left: 20px;
  color: white;
  font-size: 18px;
  line-height: 1.4;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.6);
  padding:0 20px;
  text-align:center
}

.image-text p {
   color:white !important;}

.image-text h3 {
  font-size: 1.8rem;
  font-weight: bold;
   color:white !important;
}

.highlight {
  color: #ffc107;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 992px) {

.reset-wrapper{
min-height:70vh
}
  .reset-container {
    flex-direction: column;
    padding: 20px;
  }

  .reset-right, .reset-left {
    max-width: 100%;
    width: 100%;
  }

  .reset-left {
    padding: 20px;
  }

  .image-text {
    font-size: 16px;
  }
}
`}
            </style>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendOtp;
